export const IS_EXPLAINER_MODAL_DISMISSED_KEY =
  'promo-explainer-modal-dismissed'

export const setIsExplainerModalDismissed = (promoKey?: string) => {
  try {
    window.localStorage.setItem(
      IS_EXPLAINER_MODAL_DISMISSED_KEY,
      promoKey ?? '',
    )
    return undefined
  } catch (e) {
    return undefined
  }
}

export const isExplainerModalDismissed = (promoKey?: string) => {
  try {
    if (!promoKey) return false
    const item = window.localStorage.getItem(IS_EXPLAINER_MODAL_DISMISSED_KEY)
    return item !== null && item === promoKey
  } catch (error) {
    return false
  }
}
